export const getRateByCurrency = (
  rates: Record<string, number>,
  topCurrency: string,
  bottomCurrency: string
) => {
  const topRate = rates[topCurrency];
  const bottomRate = rates[bottomCurrency];
  const rate = (1 / topRate) * bottomRate;

  return isNaN(rate) ? 0 : rate;
};
